import React from "react";
import { Box, Typography } from "@mui/material";


const PageCover = ({ title, image, subtitle}) => {
  return (
    <>
      <Box
        sx={{
          minHeight: "43vh",
          backgroundImage: `url(${image})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          color: "#fff",
          textAlign: "center",
          position: "relative",
        }}
        className="coverAfter"
      >
        <Box className="coverContent">
          <Typography variant="h1" style={{fontSize: '70px', fontWeight:'100', letterSpacing: '1px'}}>{title}</Typography>
          {subtitle && (
            <Typography variant="subtitle1" sx={{ mt: 1, fontSize: '20px', fontWeight:'200', letterSpacing: '0.5px'}}>
              {subtitle}
            </Typography>
          )}
        </Box>
      </Box>
    </>
  );
};

export default PageCover;
